import { CommonApi } from '@/types/Facet'

export const useFetchPrefs = async (selectedPrefId: number) => {
  const { $commonApiDomain } = useNuxtApp();

  // 都道府県データを取得
  const { data: fetchPrefs } = await useFetch(`${$commonApiDomain}/v3/prefs/`, {
    key: 'mansionPrefs',
    transform: (data: CommonApi) => {
      const prefList: CommonApi[] = data ? data.response_json_body : [];
      // 選択中の都道府県IDに一致する都道府県名も取得
      const prefItem = prefList.find(item => item.id === selectedPrefId);
      const prefName = prefItem ? prefItem.name : "";
      return { prefList, prefName };
    }
  });
  return { fetchPrefs };
};